import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import Scroll from 'react-scroll';
import { container } from '@Container';
import { TYPES } from '@Types';
import { Book, BuildStatus } from '@Models';
import { ArmiesAction, BookAction, VersionsAction } from '@Redux/actions';
import { BookNewParams } from '@Components/publication/book-new/validate';
import BookNewForm from '@Components/publication/book-new/book-new.form';
import { BookNewPresenter } from '@Selectors/publication/book/new/book-new.presenter';
import myBuilderSlice from '@Redux/reducers/builder/myBuilder.slice';

const BookNewComponent: React.FC<Props> = ({
                                             loadVersions,
                                             loadArmies,
                                             cancel,
                                             datas,
                                             handleSubmit
                                           }) => {
  useEffect(() => {
    loadVersions();
    loadArmies();

    Scroll.scroller.scrollTo('new-book-element', {
      duration: 1000,
      delay: 100,
      smooth: true,
      offset: -50 // Scrolls to element + 50 pixels down the page
    });
  }, []);
  const Element = Scroll.Element;

  return (
    <div className="mt-2">
      <Element name="new-book-element" />
      {datas.isLoading && <div className="loader" />}
      {!datas.isLoading &&
        <BookNewForm versions={datas.versions}
                     armies={datas.armies}
                     cancel={cancel}
                     onSubmit={handleSubmit}
                     canSubmit={datas.canSubmit} />}
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  datas: BookNewPresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => {

  const armiesAction = container.get<ArmiesAction>(TYPES.Actions.ArmiesAction);
  const versionsAction = container.get<VersionsAction>(TYPES.Actions.VersionsAction);
  const bookAction = container.get<BookAction>(TYPES.Actions.Publication.BookAction);
  return {
    cancel: () => dispatch(myBuilderSlice.actions.cancel()),
    handleSubmit: (values: BookNewParams) => {
      const book: Book = {
        id: '',
        name: values.name,
        versionId: values.versionId,
        armyId: values.armyId,
        armyName: '',
        armyLogo: null,
        updatedAt: 0,
        buildAt: null,
        buildUrl: null,
        buildStatus: BuildStatus.NotBuilt,
        sections: []
      };
      dispatch(bookAction.create(book));
    },
    loadVersions: () => dispatch(versionsAction.fetchData()),
    loadArmies: () => dispatch(armiesAction.fetchData())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookNewComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>